/**
 * 项目管理
 */
const ProjectDescRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  redirect: '/project/check/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    // 考勤详情
    {
      path: 'check/:id/:projectId/:companyId',
      name: 'check_time_desc',
      hidden: true,
      component: () => import('@/views/check_time/commdesc'),
      meta: {
        title: '考勤详情'
      }
    },
    // 考勤待处理的详情
    {
      path: 'check/pend/:id/:projectId/:companyId',
      name: 'check_time_pend_desc',
      hidden: true,
      component: () => import('@/views/check_time/pending/desc'),
      meta: {
        title: '考勤详情'
      }
    }
  ]
}

export default ProjectDescRouter
